import {ErrorhandleService} from '../../agent/service/errorhandle.service';
import {RequestService} from '../service/request.service';
import {SessionService} from '../service/session.service';
import {Router} from '@angular/router';

export function ErrorhandleFactory(sessionService: SessionService, requestService: RequestService, router: Router) {
  return new ErrorhandleService(sessionService, requestService, router);
};



// WEBPACK FOOTER //
// ./src/app/shared/factory/errorhandlerfactory.ts